import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Primitive, styled, keyframes } from '@miro-site/ui-styled-engine';
import { variantsStyles, variantsTypesStyles } from '../typography/Typography.styled';
var buttonAttributes = {
  variants: {
    primary: 'primary',
    danger: 'danger'
  },
  appearances: {
    filled: 'filled',
    outlined: 'outlined',
    flat: 'flat'
  },
  sizes: {
    small: 'small',
    medium: 'medium',
    large: 'large'
  }
};
var spinnerAnimation = keyframes({
  '100%': {
    transform: 'rotate(1turn)'
  }
});
var ButtonStyled = styled(Primitive.button, _objectSpread(_objectSpread({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  border: '$border-widths$sm solid transparent',
  userSelect: 'none',
  cursor: 'pointer',
  // background, border, fonts and insets are set according to compoundVariants
  backgroundColor: '$$buttonBackgroundColor',
  borderColor: '$$buttonBorderColor',
  insetLeft: '$$buttonInsetLeft',
  insetRight: '$$buttonInsetRight',
  // overflow styles
  whiteSpace: 'nowrap',
  maxWidth: '100%'
}, variantsTypesStyles['body-text']), {}, {
  // text content
  '& span': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    color: '$$buttonFontColor'
  },
  '& svg': {
    width: '$$buttonIconSize',
    minWidth: '$$buttonIconSize',
    color: '$$buttonFontColor',
    verticalAlign: 'middle'
  },
  // we need to hide the content when it's loading
  '& > *:not([data-button-loader])': {
    visibility: '$$buttonContentVisibility'
  },
  '& svg[data-button-loader]': {
    position: 'absolute',
    margin: 'auto',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    animation: "".concat(spinnerAnimation, " 1s linear infinite")
  },
  // focus and disabled states are universal
  '.keyboard-a11y &:focus': {
    outline: '$border-widths$lg solid $focus-ring-default'
  },
  // expand content touch area
  '&:after': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  // Styles defined according to the [Figma file](https://www.figma.com/file/b847j8bgTKPeiPAjL1vH03)
  variants: {
    // variant and appearance styles are defined together as compoundVariants
    variant: {
      // variants names aren't included if we don't pass any object
      // passing a dummy attribute enables more accurate testing
      primary: {
        noStyles: true
      },
      danger: {
        noStyles: true
      }
    },
    appearance: {
      filled: {
        noStyles: true
      },
      outlined: {
        noStyles: true
      },
      flat: {
        noStyles: true
      }
    },
    size: {
      small: _objectSpread({
        height: '32px',
        $$buttonIconSize: '$sizes-icon-200',
        $$buttonInsetLeft: '$space-inset-200',
        $$buttonInsetRight: '$space-inset-200'
      }, variantsStyles['body-text-2']),
      medium: _objectSpread({
        height: '40px',
        $$buttonIconSize: '$sizes-icon-300',
        $$buttonInsetLeft: '$space-inset-200',
        $$buttonInsetRight: '$space-inset-200'
      }, variantsStyles['body-text-1']),
      large: _objectSpread({
        height: '48px',
        $$buttonIconSize: '$sizes-icon-300',
        $$buttonInsetLeft: '$space-inset-300',
        $$buttonInsetRight: '$space-inset-300'
      }, variantsStyles['body-text-1'])
    },
    // icons paddings are defined inside compoundVariants
    startIcon: {
      "true": {
        '& span': {
          offsetLeft: '$50'
        }
      }
    },
    endIcon: {
      "true": {
        '& span': {
          offsetRight: '$50'
        }
      }
    },
    rounded: {
      "true": {
        borderRadius: '$half'
      },
      "false": {
        borderRadius: '$50'
      }
    },
    loading: {
      "true": {
        $$buttonContentVisibility: 'hidden',
        pointerEvents: 'none'
      }
    },
    fluid: {
      "true": {
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }
    },
    disabled: {
      "true": {
        $$buttonBackgroundColor: '$colors$background-cta-disabled',
        $$buttonFontColor: '$colors$font-default-disabled',
        $$buttonBorderColor: 'transparent',
        pointerEvents: 'none'
      }
    }
  },
  compoundVariants: [{
    size: 'small',
    startIcon: true,
    css: {
      $$buttonInsetLeft: '$space-inset-100'
    }
  }, {
    size: 'small',
    endIcon: true,
    css: {
      $$buttonInsetRight: '$space-inset-100'
    }
  }, {
    size: 'medium',
    startIcon: true,
    css: {
      $$buttonInsetLeft: '$space-inset-100'
    }
  }, {
    size: 'medium',
    endIcon: true,
    css: {
      $$buttonInsetRight: '$space-inset-100'
    }
  }, {
    size: 'large',
    startIcon: true,
    css: {
      $$buttonInsetLeft: '$space-inset-200'
    }
  }, {
    size: 'large',
    endIcon: true,
    css: {
      $$buttonInsetRight: '$space-inset-200'
    }
  }, {
    appearance: 'filled',
    variant: 'primary',
    disabled: false,
    css: {
      $$buttonBackgroundColor: '$colors$background-cta-idle',
      $$buttonFontColor: '$colors$font-tertiary',
      $$buttonBorderColor: 'transparent',
      '&:hover': {
        $$buttonBackgroundColor: '$colors$background-cta-hover'
      },
      '&:active': {
        $$buttonBackgroundColor: '$colors$background-cta-active'
      },
      '.keyboard-a11y &:focus': {
        $$buttonBorderColor: '$colors$white'
      }
    }
  }, {
    appearance: 'outlined',
    variant: 'primary',
    disabled: false,
    css: {
      $$buttonBackgroundColor: '$colors$background-default-idle',
      $$buttonBorderColor: '$colors$border-cta-idle',
      $$buttonFontColor: '$colors$font-default-idle',
      '&:hover': {
        $$buttonBackgroundColor: '$colors$background-default-hover',
        $$buttonFontColor: '$colors$font-default-hover'
      },
      '&:active': {
        $$buttonBackgroundColor: '$colors$background-default-active',
        $$buttonBorderColor: '$colors$border-default-active',
        $$buttonFontColor: '$colors$font-default-active'
      }
    }
  }, {
    appearance: 'outlined',
    variant: 'danger',
    disabled: false,
    css: {
      $$buttonBackgroundColor: '$colors$background-default-idle',
      $$buttonBorderColor: '$colors$border-default-error',
      $$buttonFontColor: '$colors$font-default-error',
      '&:hover': {
        $$buttonBackgroundColor: '$colors$background-danger-hover'
      },
      '&:active': {
        $$buttonBackgroundColor: '$colors$background-danger-active'
      }
    }
  }, {
    appearance: 'flat',
    variant: 'primary',
    disabled: false,
    css: {
      $$buttonBackgroundColor: '$colors$background-default-idle',
      $$buttonFontColor: '$colors$font-default-idle',
      $$buttonBorderColor: 'transparent',
      '&:hover': {
        $$buttonBackgroundColor: '$colors$background-default-hover',
        $$buttonFontColor: '$colors$font-default-hover'
      },
      '&:active': {
        $$buttonBackgroundColor: '$colors$background-default-active',
        $$buttonFontColor: '$colors$font-default-active'
      },
      '.keyboard-a11y &:focus': {
        $$buttonBorderColor: '$colors$border-cta-idle'
      }
    }
  }],
  defaultVariants: {
    appearance: 'filled',
    variant: 'primary',
    size: 'large',
    rounded: true,
    fluid: false,
    loading: false,
    disabled: false,
    endIcon: false,
    startIcon: false
  }
}));
export { buttonAttributes };
export default ButtonStyled;